import { render, staticRenderFns } from "./lecture-main-list-title.vue?vue&type=template&id=d937ccf8"
import script from "./lecture-main-list-title.vue?vue&type=script&lang=js"
export * from "./lecture-main-list-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports